import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "./ui/button";

export default function MarketingNav() {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-50 w-full bg-background/50 backdrop-blur-xl border-b border-border">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <img src="/bookingbabe-logo.png" alt="Booking Babe" className="w-7 h-7 rounded-md object-cover" />
          <span className="font-display text-xl font-extrabold tracking-tight text-foreground">Booking Babe</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-muted-foreground">
          <a href="/#features" className="hover:text-foreground transition-colors">Features</a>
          <a href="/#pricing" className="hover:text-foreground transition-colors">Pricing</a>
        </nav>
        <div className="flex items-center gap-2">
          <Button variant="ghost" data-testid="nav-login" className="text-accent hover:text-accent hover:bg-accent/10" onClick={() => navigate("/login")}>Sign in</Button>
          <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md" data-testid="nav-signup" onClick={() => navigate("/signup")}>
            Start free trial
          </Button>
        </div>
      </div>
    </header>
  );
}
